import React, { useState } from "react";
import { Link } from "react-router-dom";
import "../assets/styles/FaqPage.scss";
import "../assets/styles/FaqPreview.scss";

const previewFaqs = [
  {
    question: "What is a football analytics platform?",
    answer:
      "A football analytics platform collects live and historical match data — shots, corners, cards, possession, momentum — and turns it into something you can actually read and use. Instead of only telling you the score is 1-0, it shows you how the match got there: which team is creating chances, whether pressure is building, and how today's numbers compare to past games. Goal Guru adds a personalization layer on top, so the stats and alerts you see are built around the teams, leagues, and match situations you care about.",
  },
  {
    question: "How can I track live football matches?",
    answer:
      "Open the Matches tab to see every match currently being played, with real-time stats like goals, shots, corners, cards, and possession. You can pin favorite matches to the top, filter by league, and tap any match for a detailed minute-by-minute view. And if you can't watch everything at once, set a Smart Alert — Goal Guru scans all live matches for you and sends a push notification the moment your conditions are met, so the action finds you instead of the other way around.",
  },
  {
    question: "What kind of data does this platform provide?",
    answer:
      "Goal Guru covers four layers of football data. Live match stats: goals, shots on/off target, corners, cards, possession, and momentum. League data: tables and standings with promotion and relegation zones, plus team performance metrics. Historical data: head-to-head records, goal distributions by 15-minute period, comeback rates, and shot efficiency. And AI analysis from Guru Vision: result confidence, projected scorelines, goals, cards, and corners. Dedicated Team Pages bring a team's form, squad, standings, and upcoming fixtures together in one place.",
  },
];

function FaqPreview() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const toggleFaq = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="faq-preview-outer" id="faq">
      {/* No FAQPage markup here: these questions are also on /faq/, and
          Google wants a repeated FAQ marked up once per site (FaqPage.tsx). */}

      <div className="faq-preview-header">
        <span className="section-eyebrow">FAQ</span>
        <h2 className="section-title">
          Football Analytics Platform: Common Questions
        </h2>
      </div>

      <div className="faq-list faq-preview-list">
        {previewFaqs.map((faq, index) => (
          <div
            key={faq.question}
            className={`faq-item ${openIndex === index ? "open" : ""}`}
            onClick={() => toggleFaq(index)}
          >
            <div className="faq-question">
              <h3>{faq.question}</h3>
              <span className="faq-icon">
                {openIndex === index ? "−" : "+"}
              </span>
            </div>
            <div
              className="faq-answer"
              style={{ display: openIndex === index ? "block" : "none" }}
            >
              <p>{faq.answer}</p>
            </div>
          </div>
        ))}
      </div>

      <Link to="/faq/" className="faq-preview-link">
        View all FAQs →
      </Link>
    </div>
  );
}

export default FaqPreview;
